<template>
  <div id="new-lgb-team-members-edit">
    <overlay-loading-progress
      :LoadingFlag="OverlayLoadingFlag"
    ></overlay-loading-progress>
    <!-- Dialogs remain unchanged to preserve functionality -->
    <v-dialog v-model="memberDocumentPrompt" persistent scrollable>
      <upload-selected-member-document
        :record="SelectedMember"
        v-if="memberDocumentPrompt"
        :showDialog="memberDocumentPrompt"
        @hideDialog="hideMemberDocumentPrompt($event)"
      ></upload-selected-member-document>
    </v-dialog>
    <v-dialog v-model="memberPhotoPrompt" persistent scrollable>
      <upload-selected-member-photo
        :record="SelectedMember"
        v-if="memberPhotoPrompt"
        :showDialog="memberPhotoPrompt"
        @hideDialog="hideMemberPhotoPrompt($event)"
      ></upload-selected-member-photo>
    </v-dialog>

    <!-- Main card with enhanced design -->
    <v-card class="main-card elevation-5 rounded-lg overflow-hidden">
      <!-- Header -->
      <v-app-bar
        color="primary"
        dark
        elevate-on-scroll
        class="header-gradient"
        scroll-target="#scrolling-techniques-7"
      >
        <v-icon left>mdi-account-edit</v-icon>
        <v-toolbar-title class="font-weight-medium">
          {{ pageDescription }} {{ NextYearName }}
        </v-toolbar-title>

        <v-spacer></v-spacer>

        <v-btn icon dark @click="closePrompt" class="transition-swing">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-app-bar>

      <!-- Scrollable content area with enhanced styling -->
      <v-sheet
        id="scrolling-techniques-7"
        class="overflow-y-auto content-container"
        max-height="600"
      >
        <v-container class="py-4">
          <v-form ref="form1" v-model="valid1" lazy-validation id="createForm">
            <!-- Loading spinner and progress indicators -->
            <div class="d-flex justify-content-center mb-4" v-if="LoadingFlag">
              <v-progress-circular
                indeterminate
                color="primary"
                size="50"
              ></v-progress-circular>
            </div>

            <v-container v-if="StartupLoadingFlag" class="px-0">
              <v-row wrap>
                <v-col cols="12" md="4" v-for="n in 6" :key="n">
                  <v-skeleton-loader
                    v-bind="attrs"
                    type="paragraph"
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
            </v-container>

            <v-row wrap v-if="ProgessStart == 1" class="upload-progress">
              <v-col align="center" cols="12" md="12">
                <v-progress-circular
                  :rotate="180"
                  :size="100"
                  :width="15"
                  :value="uploadPercentage"
                  color="#00a4ef"
                  class="mb-3"
                >
                  {{ uploadPercentage }}
                </v-progress-circular>
                <div class="upload-message">
                  Please wait, we are uploading your details.
                  <span class="font-italic"
                    >Time may vary based on your internet connection.</span
                  >
                </div>
              </v-col>
            </v-row>

            <!-- Main form content with beautiful cards -->
            <v-container v-if="!StartupLoadingFlag" class="px-0">
              <!-- Required field notice -->
              <div class="required-field-notice mb-5">
                <v-icon color="error" small class="mr-1"
                  >mdi-alert-circle</v-icon
                >
                <span class="text-caption"
                  >Fields marked with
                  <span class="text-error font-weight-bold">*</span> are
                  required</span
                >
              </div>

              <!-- Selection card -->
              <v-card class="selection-card mb-5 rounded-lg elevation-2">
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="6">
                      <div class="field-label">
                        <span class="text-error font-weight-bold mr-1">*</span>
                        Designation
                      </div>
                      <v-text-field
                        v-model="DesignationName"
                        outlined
                        dense
                        readonly
                        hide-details="auto"
                        class="selection-input"
                        prepend-inner-icon="mdi-shield-account"
                        background-color="#f5f5f5"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="field-label">
                        <span class="text-error font-weight-bold mr-1">*</span>
                        Member
                      </div>
                      <v-autocomplete
                        @change="getMemberDetails"
                        :reduce="(option) => option.value"
                        :loading="MemberIdOptionsLoading"
                        :items="MemberIdOptions"
                        :rules="MemberIdRules"
                        v-model="MemberId"
                        required
                        outlined
                        dense
                        clearable
                        hide-details="auto"
                        placeholder="Select member"
                        class="selection-input"
                        prepend-inner-icon="mdi-account-search"
                      >
                        <template v-slot:selection="{ item }">
                          <v-avatar size="24" class="mr-2">
                            <img :src="item.photo" alt="Member Photo" />
                          </v-avatar>
                          {{ item.text }}
                        </template>
                        <template v-slot:item="{ item }">
                          <v-avatar size="30" class="mr-2">
                            <img :src="item.photo" alt="Member Photo" />
                          </v-avatar>
                          {{ item.text }}
                        </template>
                      </v-autocomplete>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Member details card -->
              <v-card
                v-if="MemberFlag"
                class="member-details-card mb-5 rounded-lg elevation-2"
              >
                <v-card-title class="primary--text pb-1">
                  <v-icon color="primary" class="mr-2"
                    >mdi-account-details</v-icon
                  >
                  Member Details
                </v-card-title>
                <v-card-subtitle class="pb-0 pt-1"
                  >Member profile information and status</v-card-subtitle
                >
                <v-divider class="mx-4"></v-divider>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <div class="field-label">
                        <span class="text-error font-weight-bold mr-1">*</span>
                        Date of Birth
                      </div>
                      <v-menu
                        v-model="menu1"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        lazy
                        transition="scale-transition"
                        offset-y
                        full-width
                        min-width="290px"
                        :disabled="!!SelectedMember.member_dob"
                      >
                        <template v-slot:activator="{ on }">
                          <v-text-field
                            required
                            v-model="SelectedMember.DOB"
                            label="Date of Birth"
                            persistent-hint
                            readonly
                            v-on="!SelectedMember.DOB ? on : {}"
                            background-color="#F3F6F9"
                            class="date-input"
                            validate-on-blur
                            solo
                            dense
                            :disabled="!!SelectedMember.DOB"
                            prepend-inner-icon="mdi-calendar"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="SelectedMember.DOB"
                          @input="menu1 = false"
                          :disabled="!!SelectedMember.DOB"
                          class="elevation-5"
                        ></v-date-picker>
                      </v-menu>
                      <div class="mt-1" v-if="SelectedMember.AadhaarVerifiedFlag">
                        <v-chip
                          x-small
                          :color="
                            SelectedMember.AadhaarVerifiedFlag
                              ? 'success'
                              : 'warning'
                          "
                          text-color="white"
                          class="verification-chip"
                        >
                          <v-icon left x-small>{{
                            SelectedMember.AadhaarVerifiedFlag
                              ? "mdi-check-circle"
                              : "mdi-alert-circle"
                          }}</v-icon>
                          {{
                            SelectedMember.AadhaarVerifiedFlag
                              ? "DOB verified by Aadhaar"
                              : "DOB not verified by Aadhaar"
                          }}
                        </v-chip>
                      </div>
                    </v-col>

                    <!-- Status chips with improved visual design -->
                    <v-col cols="12" sm="6" md="2">
                      <div class="field-label">Profile Update</div>
                      <v-chip
                        :color="SelectedMember.ProfileUpdatedColor"
                        label
                        class="status-chip text-white"
                      >
                        <v-icon left small color="white">
                          {{
                            SelectedMember.ProfileStatusFlag
                              ? "mdi-check-circle"
                              : "mdi-clock-outline"
                          }}
                        </v-icon>
                        {{ SelectedMember.ProfileUpdatedTxt }}
                      </v-chip>
                      <br />
                      <div
                        v-if="SelectedMember.MissingSteps"
                        class="pa-3 rounded-lg text-center mt-2"
                        style="
                          background-color: #fff3cd;
                          color: #856404;
                          border: 1px solid #ffeeba;
                        "
                      >
                        <strong>⚠️ Missing Steps:</strong>
                        {{ SelectedMember.MissingSteps }}
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6" md="2">
                      <div class="field-label">
                        <span class="text-error font-weight-bold mr-1">*</span>
                        Photo Update
                      </div>
                      <div class="d-flex align-center">
                        <v-chip
                          :color="
                            SelectedMember.MemberImageFlag ? 'success' : 'warning'
                          "
                          label
                          class="status-chip mr-2"
                        >
                          <v-icon left small>{{
                            SelectedMember.MemberImageFlag
                              ? "mdi-check-circle"
                              : "mdi-clock-outline"
                          }}</v-icon>
                          {{
                            SelectedMember.MemberImageFlag ? "Completed" : "Pending"
                          }}
                        </v-chip>
                        <v-btn
                          icon
                          small
                          color="primary"
                          @click.prevent="memberPhotoPrompt = true"
                          v-if="!SelectedMember.MemberImageFlag"
                        >
                          <v-icon>mdi-cloud-upload</v-icon>
                        </v-btn>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6" md="2">
                      <div class="field-label">
                        <span class="text-error font-weight-bold mr-1">*</span>
                        Age Proof Document
                      </div>
                      <div class="d-flex align-center">
                        <v-chip
                          :color="
                            SelectedMember.DocumentFlag ? 'success' : 'warning'
                          "
                          label
                          class="status-chip mr-2"
                        >
                          <v-icon left small>{{
                            SelectedMember.DocumentFlag
                              ? "mdi-check-circle"
                              : "mdi-clock-outline"
                          }}</v-icon>
                          {{
                            SelectedMember.DocumentFlag
                              ? "Completed"
                              : "Pending"
                          }}
                        </v-chip>
                        <v-btn
                          icon
                          small
                          color="primary"
                          @click.prevent="memberDocumentPrompt = true"
                          v-if="!SelectedMember.DocumentFlag"
                        >
                          <v-icon>mdi-cloud-upload</v-icon>
                        </v-btn>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6" md="2" v-if="SelectedMember.AadhaarVerifiedFlag">
                      <div class="field-label">
                        <span class="text-error font-weight-bold mr-1">*</span>
                        Aadhaar Status
                      </div>
                      <v-chip
                        :color="SelectedMember.AadhaarTextColor"
                        label
                        class="status-chip text-white"
                      >
                        <v-icon left small>{{
                          SelectedMember.AadhaarVerifiedFlag
                            ? "mdi-check-circle"
                            : "mdi-alert-circle"
                        }}</v-icon>
                        {{ SelectedMember.AadhaarVerifiedTxt }}
                      </v-chip>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Aadhaar Card Section -->
              <v-expand-transition>
                <v-card
                  v-if="
                    MemberFlag > 0 &&
                    SelectedMember.AadhaarVerifiedFlag
                  "
                  class="aadhaar-card mb-5 rounded-lg elevation-2"
                >
                  <v-card-title class="aadhaar-card-title">
                    <v-icon color="primary" class="mr-2"
                      >mdi-card-account-details</v-icon
                    >
                    Verified Aadhaar Details
                  </v-card-title>
                  <v-divider class="mx-4"></v-divider>
                  <v-card-text class="pa-4">
                    <v-card
                      elevation="0"
                      class="aadhaar-real-card mx-auto"
                      rounded="lg"
                      max-width="550px"
                      outlined
                    >
                      <!-- Aadhaar Card Outer Wrapper -->
                      <div class="aadhaar-outer-wrapper">
                        <!-- Aadhaar Header with emblem and flag colors -->
                        <div
                          class="aadhaar-header d-flex align-center px-3 py-2"
                        >
                          <!-- National emblem -->
                          <div class="emblem-container mr-2">
                            <v-img
                              src="https://upload.wikimedia.org/wikipedia/commons/5/55/Emblem_of_India.svg"
                              max-height="32"
                              contain
                              alt="Emblem"
                            ></v-img>
                          </div>
                          <!-- Title and flag colors -->
                          <div
                            class="aadhaar-title-container text-center flex-grow-1"
                          >
                            <div
                              class="govt-title-hindi"
                              style="color: black !important"
                            >
                              भारत सरकार
                            </div>
                            <div
                              class="govt-title-english"
                              style="color: #333 !important"
                            >
                              Government of India
                            </div>
                          </div>

                          <!-- UIDAI logo -->
                          <div class="uidai-logo-container ml-2">
                            <div class="aadhaar-logo font-weight-bold">
                              <span class="blue--text">आधार</span>
                            </div>
                          </div>
                        </div>

                        <!-- Flag colors strip -->
                        <div class="aadhaar-flag-colors">
                          <div class="saffron-line"></div>
                          <div class="white-line">
                            <div class="ashoka-chakra">
                              <v-icon x-small color="#000080"
                                >mdi-asterisk</v-icon
                              >
                            </div>
                          </div>
                          <div class="green-line"></div>
                        </div>

                        <!-- Main Content -->
                        <v-card-text class="pa-4">
                          <div class="d-flex aadhaar-content">
                            <!-- Left section with photo -->
                            <div class="aadhaar-photo-section mr-4">
                              <v-avatar
                                size="90"
                                class="aadhaar-photo-container mb-3"
                              >
                                <img
                                  v-if="SelectedMember.PhotoUrl"
                                  :src="SelectedMember.PhotoUrl"
                                  alt="Aadhaar Photo"
                                  class="aadhaar-photo"
                                />
                                <v-icon v-else size="50" color="#555555"
                                  >mdi-account</v-icon
                                >
                              </v-avatar>
                            </div>

                            <!-- Right section with details -->
                            <div class="aadhaar-details-section flex-grow-1">
                              <div class="person-name-bilingual">
                                <div class="name-hindi mb-1">
                                  {{ SelectedMember.AadhaarName || "NA" }}
                                </div>
                                <div class="name-english">
                                  {{ SelectedMember.AadhaarName || "NA" }}
                                </div>
                              </div>

                              <div class="detail-row mt-2">
                                <span class="detail-label"
                                  ><b>Date of Birth:</b></span
                                >
                                <span class="detail-value">{{
                                  SelectedMember.AadhaarDob || "NA"
                                }}</span>
                              </div>

                              <div class="detail-row">
                                <span class="detail-label"><b>Gender:</b></span>
                                <span class="detail-value">{{
                                  SelectedMember.AadhaarGender || "NA"
                                }}</span>
                              </div>

                              <div>
                                <span class="detail-label"
                                  ><b>Address:</b></span
                                >
                                <span class="detail-value address-text">{{
                                  SelectedMember.AadhaarAddress || "NA"
                                }}</span>
                              </div>

                              <!-- Aadhaar Number with stylized display -->
                              <div class="aadhaar-number-container mt-2">
                                <div class="aadhaar-number-label">
                                  आधार / Aadhaar
                                </div>
                                <div class="aadhaar-number">
                                  <template v-if="SelectedMember.AadhaarNumber">
                                    <span class="aadhaar-digit-space"></span>
                                    <span class="aadhaar-digit-group">{{
                                      SelectedMember.AadhaarNumber
                                    }}</span>
                                    <span class="aadhaar-digit-space"></span>
                                  </template>
                                  <template v-else>XXXX XXXX XXXX</template>
                                </div>
                              </div>
                            </div>
                          </div>

                          <!-- Red separator line -->
                          <div class="aadhaar-separator-line mt-3"></div>

                          <!-- Footer -->
                          <div
                            class="aadhaar-footer d-flex justify-space-between align-center mt-1"
                          >
                            <div class="aadhaar-issue-info caption">
                              <div class="issue-date">
                                Issued:
                                {{
                                  SelectedMember.AadhaarIssueDate ||
                                  "01/01/2023"
                                }}
                              </div>
                            </div>
                            <div class="aadhaar-tagline">
                              <span class="tagline-text-hindi"
                                >आधार - आम आदमी का अधिकार</span
                              >
                            </div>
                            <div class="verification-badge">
                              <v-chip
                                color="success"
                                x-small
                                dark
                                class="verification-chip"
                              >
                                <v-icon left x-small>mdi-check-circle</v-icon>
                                Verified
                              </v-chip>
                            </div>
                          </div>
                        </v-card-text>
                      </div>
                    </v-card>
                  </v-card-text>
                </v-card>
              </v-expand-transition>

              <!-- Important notice section -->
              <v-card class="important-card mb-5 rounded-lg elevation-2">
                <v-card-title class="important-card-title">
                  <v-icon color="amber darken-2" class="mr-2"
                    >mdi-information</v-icon
                  >
                  Important Information
                </v-card-title>
                <v-divider class="mx-4"></v-divider>
                <v-card-text class="py-4">
                  <v-list-item
                    v-for="(item, i) in [
                      'The elected member should have completed their profile updation in their Members Portal.',
                      'The elected member should have their photo uploaded in their profile or you can do it from here by clicking the upload button.',
                      'The elected member should have uploaded their age proof document in their Members Portal or you can do it from here by clicking the upload button.',
                    ]"
                    :key="i"
                    class="px-0"
                  >
                    <v-list-item-icon class="mr-3">
                      <v-avatar
                        size="24"
                        color="amber lighten-4"
                        class="important-list-icon"
                      >
                        <span
                          class="amber--text text--darken-4 font-weight-bold"
                          >{{ i + 1 }}</span
                        >
                      </v-avatar>
                    </v-list-item-icon>
                    <v-list-item-content>
                      <v-list-item-title class="important-list-text">{{
                        item
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-card-text>
              </v-card>
            </v-container>
          </v-form>
        </v-container>
      </v-sheet>

      <!-- Footer action buttons -->
      <v-divider></v-divider>
      <v-card-actions class="pa-4 action-buttons">
        <v-spacer></v-spacer>
        <v-btn
          @click="closePrompt"
          elevation="2"
          rounded
          color="error"
          class="action-btn px-6 mr-4 font-weight-medium"
        >
          <v-icon left>mdi-close-circle</v-icon>
          Cancel
        </v-btn>
        <v-btn
          :disabled="!valid1"
          @click.prevent="confirmAlert"
          :loading="SubmitFlag"
          elevation="2"
          rounded
          color="success"
          class="action-btn px-6 font-weight-medium"
        >
          <v-icon left>mdi-content-save</v-icon>
          Save
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import UploadSelectedMemberDocument from "@/view/pages/members/UploadSelectedMemberDocument.vue";
import UploadSelectedMemberPhoto from "@/view/pages/members/UploadSelectedMemberPhoto.vue";
import Swal from "sweetalert2";

export default {
  mixins: [common],
  components: {
    UploadSelectedMemberDocument,
    UploadSelectedMemberPhoto,
  },
  props: {
    editRecordPrompt: {
      type: Boolean,
      required: true,
    },
    recordData: {
      required: true,
    },
    pageDescription: {
      type: String,
    },
  },
  data() {
    return {
      valid1: true,

      menu1: false,
      SelectedMember: {},

      memberDocumentPrompt: false,
      memberPhotoPrompt: false,

      search: "",
      selected: [],
      tableSelectFlag1: false,
      SubmitFlag: false,

      rows: [],
      tableColumns1: [],
      records: [],

      alert: {},

      ProgessStart: 0,
      uploadPercentage: 0,

      SuccessMessageTxtFlag: 0,
      SuccessMessageTxt: "",

      ErrorMessageTxtFlag: 0,
      ErrorMessageTxt: "",

      ResultFlag: false,
      LoadingFlag: false,
      StartupLoadingFlag: false,
      OverlayLoadingFlag: false,

      AllMembers: [],

      LomCode: "",

      YearCodeRules: [(v) => !!v || "Year is required"],
      YearCode: "",
      YearCodeOptions: [],
      YearCodeOptionsLoading: false,

      TeamCodeRules: [(v) => !!v || "Team is required"],
      TeamCode: "",
      TeamCodeOptions: [],
      TeamCodeOptionsLoading: false,

      ZoneCodeRules: [(v) => !!v || "Zone is required"],
      ZoneCode: "",
      ZoneCodeOptions: [],
      ZoneCodeOptionsLoading: false,

      MembershipId: "",
      MemberFlag: false,

      MemberIdRules: [(v) => !!v || "Member is required"],
      MemberId: "",
      MemberIdOptions: [],
      MemberIdOptionsLoading: false,

      DesignationIdRules: [(v) => !!v || "Designation is required"],
      DesignationId: "",
      DesignationIdOptions: [],
      DesignationIdOptionsLoading: false,

      DesignationName: "",

      MemberNameRules: [(v) => !!v || "Member Name is required"],
      MemberName: "",

      EmailIdRules: [],
      EmailId: "",

      MobileNoRules: [],
      MobileNo: "",

      Address: "",

      CityNameRules: [],
      CityName: "",

      uploadedImages: [],

      FacebookRules: [],
      Facebook: "",

      TwitterRules: [],
      Twitter: "",

      InstagramRules: [],
      Instagram: "",

      CurrentYearId: "",
      MemberTypeId: "",

      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      JciYearCode: "",
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
    };
  },
  computed: {},
  watch: {
    PageInfo: function () {
      console.log("watch PageInfo");
      this.LoadingFlag = false;
      var tr = this.PageInfo;
      console.log({ tr });
      var n1 = Object.keys(tr).length;
      console.log({ n1 });
      if (n1 > 0) {
        this.PageTitle = tr.PageTitle;
        this.PageDescription = tr.PageDescription;

        var CurrentJciYearId = parseInt(tr.CurrentJciYearId);
        console.log({ CurrentJciYearId });
        this.JciYearCode = CurrentJciYearId;

        var YearName = parseInt(tr.CurrentJciYearName);
        console.log({ YearName });
        this.YearName = YearName;

        var NextJciYearId = parseInt(tr.NextJciYearId);
        console.log({ NextJciYearId });
        this.NextYearCode = NextJciYearId;

        var NextJciYearName = parseInt(tr.NextJciYearName);
        console.log({ NextJciYearName });
        this.NextYearName = NextJciYearName;

        this.CurrentYearId = NextJciYearId;

        var LomId = this.$session.get("LomId");
        LomId = LomId == (null || undefined) ? "" : LomId;
        this.LomCode = LomId;

        this.pageData();
      }
    },
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    rows: function () {
      console.log("watch rows");
      var n1 = this.rows.length;
      var flag = n1 == 0 ? 0 : 1;
      console.log("n1=" + n1 + ", flag=" + flag);
      this.records = this.rows[0];
    },
    YearCodeOptions: function () {
      this.YearCodeOptionsLoading = false;
    },
    TeamCodeOptions: function () {
      this.TeamCodeOptionsLoading = false;
    },
    ZoneCodeOptions: function () {
      this.ZoneCodeOptionsLoading = false;
    },
    MemberIdOptions: function () {
      this.MemberIdOptionsLoading = false;
      this.getMemberDetails();
    },
    DesignationIdOptions: function () {
      this.DesignationIdOptionsLoading = false;
    },
  },
  created() {
    // this.initialize()
  },
  methods: {
    hideMemberDocumentPrompt(flag) {
      console.log("hideMemberDocumentPrompt called");
      console.log({ flag });
      this.memberDocumentPrompt = false;
      if (flag) {
        this.SelectedMember.DocumentFlag = true;
      }
    },
    hideMemberPhotoPrompt(flag) {
      console.log("hideMemberPhotoPrompt called");
      console.log({ flag });
      this.memberPhotoPrompt = false;
      if (flag) {
        this.SelectedMember.MemberImageFlag = true;
      }
    },
    refreshPageData() {
      console.log("refreshPageData called");
      this.LoadingFlag = true;
      var url1 = "api/menu-details/show";
      var condition1 = {
        UserInterface: 1,
        Module: "lgb_dis",
        Action: "list",
      };
      this.getPageDetails("PageInfo", {}, url1, condition1);
    },
    pageData() {
      console.log("pageData called");
      var recordData = this.recordData;
      console.log("recordData=" + JSON.stringify(recordData));
      var YearwiseOfficesHeldId = recordData.YearwiseOfficesHeldId;
      if (YearwiseOfficesHeldId != "") {
        this.getDesignationIdOptions();
        this.MemberId = recordData.MemberId;
        this.DesignationName = recordData.DesignationName;
        this.ZoneCode = recordData.ZoneId;
        this.LomId = recordData.LomId;
        var DesignationId = recordData.DesignationId;
        var MemberTypeId = "";
        switch (DesignationId) {
          case 14:
            // Junior Jaycee Wing
            MemberTypeId = 9;
            break;

          case 15:
            // Jayceert Wing
            MemberTypeId = 8;
            break;

          default:
            MemberTypeId = 1;
            break;
        }
        this.DesignationId = DesignationId;
        this.MemberTypeId = MemberTypeId;
        this.getMemberIdOptions();
      } else {
        this.sweetAlert("error", "Designation details not fount", false);
        this.closePrompt();
      }
    },
    validate() {
      console.log("validate called");
      this.$refs.form1.validate();
    },
    reset() {
      console.log("reset called");
      this.$refs.form1.reset();
    },
    resetValidation() {
      console.log("resetValidation called");
      this.$refs.form1.resetValidation();
    },
    closePrompt() {
      console.log("closePrompt called");
      this.$emit("hideEditRecordPrompt", this.ResultFlag);
    },
    resetMessageTxt() {
      console.log("resetMessageTxt called");
      this.ErrorMessageTxt = 0;
      this.ErrorMessageTxtFlag = "";
      this.SuccessMessageTxtFlag = 0;
      this.SuccessMessageTxt = "";
    },
    onFileSelected(event, k) {
      console.log("onFileSelected called");
      var n1 = this.uploadedImages.length;
      var file = event.target.files[0];
      console.log("k=" + k + ", event=" + JSON.stringify(file));
      this.uploadedImages[k] = file;
    },
    addNewRow(tableId) {
      console.log("addNewRow called");
      console.log("tableId=" + tableId);

      if (tableId == 2) {
        var n1 = this.AllMembers.length;
        console.log("n1=" + n1);
        // if (n1 < 30) {
        this.AllMembers.push({
          YearwiseOfficesHeldId: null,
          MemberId: 0,
          MemberName: "",
          DesignationId: 0,
          Designation: "",
        });
        // }
      }
    },
    deleteRow(tableId, index, tr) {
      console.log("deleteRow called");
      console.log(
        "tableId=" + tableId + ", index=" + index + ", tr=" + JSON.stringify(tr)
      );
      if (index > -1) {
        if (tableId == 2) {
          this.AllMembers.splice(index, 1);
        }
      }
    },
    getDesignationIdOptions() {
      console.log("getDesignationIdOptions called");
      this.DesignationIdOptionsLoading = true;
      var selectbox1_source = "DesignationId";
      var selectbox1_destination = "DesignationIdOptions";
      var selectbox1_url = "api/designation/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
        OrganizationTypeId: 3,
        ExceptDesignationId: [1, 5, 6, 7],
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getMemberIdOptions() {
      console.log("getMemberIdOptions called");
      this.MemberIdOptionsLoading = true;
      var selectbox1_source = "MemberId";
      var selectbox1_destination = "MemberIdOptions";
      var selectbox1_url = "api/members/options";
      var selectbox1_conditions_array = {
        UserInterface: 2,
        LomCode: this.LomCode,
        MemberType: this.MemberTypeId,
      };
      this.getSelectBoxOptions(
        selectbox1_source,
        selectbox1_destination,
        selectbox1_conditions_array,
        selectbox1_url
      );
    },
    getMemberDetails() {
      console.log("getMemberDetails called");
      this.AllMembers = [];
      this.SelectedMember = {};
      this.MemberFlag = false;
      var temp_code = this.MemberId;
      console.log("temp_code=" + temp_code);
      var idx = this.MemberIdOptions.map((e) => e.value).indexOf(temp_code);
      console.log("idx=" + idx);
      if (idx >= 0) {
        var member = this.MemberIdOptions[idx];
        console.log("member=" + JSON.stringify(member));
        var MembershipId = member.membership_id;
        MembershipId = MembershipId == (null || undefined) ? "" : MembershipId;
        console.log({ MembershipId });
        if (MembershipId != "") {
          this.MembershipId = MembershipId;
          this.searchForm();
        }
      }
    },
    searchForm() {
      console.log("searchForm is called");
      var MembershipId = this.MembershipId;
      console.log("MembershipId=" + MembershipId);
      this.SelectedMember = {};
      this.MemberFlag = false;
      if (MembershipId != "") {
        this.OverlayLoadingFlag = true;
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url = server_url + "api/members/search";
        var upload = {
          UserInterface: 2,
          MembershipId: this.MembershipId,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );
        const thisIns = this;
        var output = "";
        var records = "";
        var flag = 0;
        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));
            // thisIns.pageLoadingOff()
            thisIns.OverlayLoadingFlag = false;
            output = response.data.output;
            flag = response.data.flag;
            console.log("output=" + output + ", flag=" + flag);

            records = response.data.records;
            console.log({ records });

            if (flag == 1) {
              thisIns.SelectedMember = records;
              thisIns.MemberFlag = true;
              // thisIns.toast("success", output);
            } else {
              thisIns.toast("error", output);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
          });
      } else {
        var message = "Membership Id is required";
        this.sweetAlert("error", message, false);
      }
    },
    confirmAlert() {
      var validate1 = this.$refs.form1.validate();
      console.log("validate1=" + validate1);
      if (validate1) {
        Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: `Save`,
          confirmButtonColor: "#3085d6",
          cancelButtonText: `Cancel`,
          cancelButtonColor: "#d33",
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
            this.submitForm();
          } else {
            this.sweetAlert("error", "You cancelled the process", true);
          }
        });
      } else {
        this.toast("error", "Kindly fill the required fields", true);
      }
    },
    submitForm() {
      // add todo in store and clear all fields in dialog
      console.log("submitForm called");

      // this.resetMessageTxt();

      var result = this.$refs.form1.validate();
      console.log("result=" + result);

      var LomCode = this.LomCode;
      var MemberId = this.MemberId;
      var SelectedMember = this.SelectedMember;
      // var n1 = AllMembers.length;

      if (result) {
        var server_url = companyConfig.apiURL;
        var token = this.$session.get("token");
        token = token == (null || undefined) ? 0 : token;
        var add_url =
          server_url +
          "api/year-wise-designation/new-governing-board-member-update";
        var upload = {
          UserInterface: 1,
          OrganizationTypeId: 3,
          YearCode: this.CurrentYearId,
          ZoneCode: this.ZoneCode,
          LomCode: this.LomCode,
          MemberId: this.MemberId,
          DesignationId: this.DesignationId,
          YearwiseOfficesHeldId: this.recordData.YearwiseOfficesHeldId,
          DateOfBirth: SelectedMember.DOB,
        };
        console.log("upload=" + JSON.stringify(upload));
        console.log(
          "server_url=" +
            server_url +
            ", token=" +
            token +
            ", add_url=" +
            add_url
        );

        this.OverlayLoadingFlag = true;
        this.ResultFlag = false;

        const thisIns = this;
        var output = "";
        var records = "";
        var successTxt = "";
        var errorTxt = "";
        var flag = 0;

        // thisIns.pageLoadingOn()

        this.$http({
          url: add_url,
          method: "POST",
          data: upload,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + token,
          },
          onUploadProgress: function (progressEvent) {
            this.uploadPercentage = parseInt(
              Math.round((progressEvent.loaded / progressEvent.total) * 100)
            );
          }.bind(this),
        })
          .then(function (response) {
            console.log("response=" + JSON.stringify(response));

            // thisIns.pageLoadingOff()
            // thisIns.ProgessStart = 0;
            thisIns.OverlayLoadingFlag = false;

            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            records = response.data.records;
            console.log("output=" + output + ", flag=" + flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log("successTxt=" + successTxt + ", errorTxt=" + errorTxt);

            if (flag == 1) {
              thisIns.ResultFlag = true;
              thisIns.closePrompt();
              thisIns.sweetAlert("success", output, true);
            } else {
              thisIns.sweetAlert("error", output, false);
            }
          })
          .catch(function (error) {
            console.log("error=" + error);
            thisIns.OverlayLoadingFlag = false;
          });
      } else {
        console.log("some errors occured");
        var message = "";
        if (LomCode == "") {
          message += "LOM should not be empty. ";
        }
        if (MemberId == "") {
          message += "Member should not be empty. ";
        }
        this.sweetAlert("error", message, false);
      }
    },
  },
  beforeMount() {
    console.log("beforeMount called");
    var LomCode = this.$session.get("LomId");
    LomCode = LomCode == (null || undefined) ? "" : LomCode;
    console.log("LomCode=" + LomCode);

    var ZoneCode = this.$session.get("ZoneId");
    ZoneCode = ZoneCode == (null || undefined) ? "" : ZoneCode;
    console.log("ZoneCode=" + ZoneCode);

    var CurrentYearId = this.$session.get("CurrentYearId");
    CurrentYearId = 12;
    CurrentYearId = CurrentYearId == (null || undefined) ? 0 : CurrentYearId;
    this.CurrentYearId = CurrentYearId;

    this.LomCode = LomCode;
    this.ZoneCode = ZoneCode;
    this.refreshPageData();
  },
};
</script>
<style lang="scss">
#new-lgb-team-members-edit {
  .v-dialog > .v-card > .v-toolbar {
    position: sticky;
    top: 0;
    z-index: 999;
  }

  // Main container and layout styles
  .main-card {
    border-radius: 12px !important;
    overflow: hidden;
  }

  .header-gradient {
    background: linear-gradient(135deg, #1976d2 0%, #2196f3 100%) !important;
  }

  .content-container {
    background-color: #f9f9fb;
  }

  .required-field-notice {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0, 0, 0, 0.03);
    padding: 8px;
    border-radius: 8px;
    border-left: 3px solid #f44336;
  }

  // Card styling
  .selection-card,
  .member-details-card,
  .important-card {
    transition: transform 0.2s, box-shadow 0.2s;
    border-radius: 8px !important;
    overflow: hidden;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.1) !important;
    }
  }

  // Form input styling
  .field-label {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 6px;
    color: rgba(0, 0, 0, 0.7);
  }

  .selection-input,
  .date-input {
    border-radius: 8px;
  }

  // Status chips styling
  .status-chip {
    min-width: 100px;
  }

  .verification-chip {
    height: 24px;
  }

  // Important notice styling
  .important-card-title {
    color: #ff8f00;
  }

  .important-list-text {
    font-size: 14px;
    line-height: 1.5;
  }

  // Action buttons styling
  .action-buttons {
    background-color: #f9f9fb;
  }

  .action-btn {
    transition: transform 0.2s, box-shadow 0.2s;
    font-size: 15px;
    letter-spacing: 0.5px;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15) !important;
    }
  }

  // Upload progress styling
  .upload-progress {
    background-color: rgba(0, 164, 239, 0.05);
    border-radius: 12px;
    padding: 24px;
    border: 1px dashed #00a4ef;
  }

  .upload-message {
    color: #f44336;
    font-weight: 500;
  }

  // Text colors
  .text-error {
    color: #f44336 !important;
  }

  /* Aadhaar Card Styles - Keeping original functionality */
  .aadhaar-real-card {
    background: white !important;
    overflow: hidden;
    border: 1px solid #e0e0e0;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.02);
    }

    .aadhaar-header {
      background-color: #f8f8f8;
      padding: 8px;
    }

    .aadhaar-title-container .govt-title-hindi {
      color: black !important;
      font-size: 14px !important;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
    }

    .aadhaar-title-container .govt-title-english {
      color: #333 !important;
      font-size: 12px !important;
      display: block !important;
      visibility: visible !important;
      opacity: 1 !important;
    }

    .govt-title-hindi {
      font-size: 14px;
      font-weight: bold;
      color: #000 !important;
      margin: 0;
      line-height: 1.2;
    }

    .govt-title-english {
      font-size: 12px;
      font-weight: 600;
      color: #333 !important;
      margin: 0;
      line-height: 1.2;
    }

    .aadhaar-flag-colors {
      display: flex;
      flex-direction: column;
      height: 6px;
      width: 100%;

      .saffron-line {
        height: 2px;
        background: #ff9933;
      }

      .white-line {
        height: 2px;
        background: #ffffff;
        position: relative;

        .ashoka-chakra {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }

      .green-line {
        height: 2px;
        background: #138808;
      }
    }

    .aadhaar-logo {
      font-size: 14px;
    }

    .aadhaar-content {
      display: flex;
      align-items: flex-start;
    }

    .aadhaar-photo-container {
      border: 1px solid #ccc;
      background: #f5f5f5;
    }

    .qr-code-container {
      border: 1px dashed #ccc;
      padding: 2px;
      background: #f9f9f9;
      width: fit-content;
    }

    .aadhaar-details-section {
      flex: 1;
    }

    .person-name-bilingual {
      .name-hindi {
        font-size: 12px;
        color: #555;
      }

      .name-english {
        font-size: 14px;
        font-weight: bold;
        color: #333;
      }
    }

    .detail-row {
      margin-bottom: 4px;

      .detail-label {
        display: inline-block;
        min-width: 90px;
        font-weight: 600;
        font-size: 12px;
        color: #555;
      }

      .detail-value {
        font-size: 12px;
        color: #333;
      }

      .address-text {
        max-width: 200px;
        display: inline-block;
        word-break: break-word;
      }
    }

    .aadhaar-number-container {
      background: #f5f5f5;
      border: 1px solid #ddd;
      border-radius: 4px;
      padding: 4px 8px;
      display: inline-block;
      max-width: 200px;

      .aadhaar-number-label {
        font-size: 9px;
        color: #666;
        margin-bottom: 2px;
      }

      .aadhaar-number {
        font-weight: bold;
        letter-spacing: 1px;
        color: #000;
        font-size: 14px;
        font-family: "Courier New", monospace;
      }
    }

    .aadhaar-separator-line {
      height: 2px;
      background: linear-gradient(
        to right,
        #f00,
        #f00 75%,
        transparent 75%,
        transparent 100%
      );
      background-size: 10px 1px;
      background-repeat: repeat-x;
    }

    .aadhaar-footer {
      .issue-date {
        font-size: 8px;
        color: #666;
      }

      .tagline-text-hindi {
        font-size: 10px;
        color: #d32f2f;
        font-weight: 500;
      }
    }
  }
}
</style>